import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import {useStore} from "../../../hooks/useStore";
import {observer} from "mobx-react-lite";
import Row from "./row";
import AlertDialog from "../../../components/dialog_modal";
import api from "../../../api/api";
import {toast} from "react-toastify";
import DynamicFormulaRow from "./dynamicFormulaRow";
import {dynamicFormulaStore} from "../../../store/store";

const Right = observer(({ageGroupSelect}) => {
    const store = useStore()

    const [name, setName] = useState('')
    const [openModal, setOpenModal] = useState(false)
    const [disciplineId, setDisciplineId] = useState('')
    const [newFormulaName, setNewFormulaName] = useState('');
    const [deleteFormulaId, setDeleteFormulaId] = useState(null);

    const handleAdded = async () => {
        await store.setting_sorev.addedDinamic(name, ageGroupSelect)
        setName('')
    }

    const handleSaveToFinal = async () => {
        await api().get(`general/discipline_result/final/${ageGroupSelect}/${disciplineId}`).then(() => {
            toast.success('Перенесено в финал')
        })
    }

    useEffect(() => {
        const getStatic = async () => {
            await store.setting_sorev.getStatic(ageGroupSelect)
        }

        if (ageGroupSelect === null) return
        getStatic()
    }, [ageGroupSelect])

    useEffect(() => {
        const getDinamic = async () => {
            await store.setting_sorev.getDinamic(ageGroupSelect)
        }

        if (ageGroupSelect === null) return
        getDinamic()
    }, [ageGroupSelect])

    useEffect(() => {
        const getDiscipline = async () => {
            await store.setting_sorev.getDiscipline()
        }

        getDiscipline()
    }, [])

    useEffect(() => {
        const getAllSumFormula = async () => {
            await dynamicFormulaStore.getAllSumFormula(ageGroupSelect);
        }

        getAllSumFormula().then(() => {
        });
    }, [ageGroupSelect]);

    const createSumFormula = () => {
        const createSumFormula = async () => {
            await dynamicFormulaStore.createSumFormula(newFormulaName);
        }

        createSumFormula().then(() => {
            setNewFormulaName('');
        })
    }

    const deleteSumFormula = (formulaId) => {
        const performDelete = async () => {
            await dynamicFormulaStore.deleteSumFormula(formulaId);
        };

        setDeleteFormulaId(formulaId); // Устанавливаем ID удаляемого элемента
        performDelete().then(() => {
            setDeleteFormulaId(null); // Сбрасываем после успеха
        }).catch(error => {
            setDeleteFormulaId(null); // Сбрасываем при ошибке
            console.error("Ошибка при удалении: ", error);
        });
    };

    const renameSumFormula = (formulaId, formulaName) => {
        const renameSumFormula = async () => {
            await dynamicFormulaStore.renameSumFormula(formulaId, formulaName);
        }

        renameSumFormula().then(() => {
        })
    }

    return (
        <div className={s.right}>
            <AlertDialog
                title={'Перенести в Финал?'}
                open={openModal} setOpen={setOpenModal} handlerConfirm={() => {
                setOpenModal(false)
                handleSaveToFinal()
            }}/>
            <h1 className={s.title}>Итоговые результаты </h1>

            <p className={s.sub_title}>Итог подсчет</p>
            <div className={s.static_res} style={{marginBottom: '40px'}}>
                {store.setting_sorev.static_res.map((el, ind) => {
                    return <div key={el.result_type_id} className={s.static_res_main}>
                        <div className={s.item_name}>{el.result_type_name}</div>
                        <button className={s.btn_save} onClick={() => {
                            setOpenModal(true)
                            setDisciplineId(el.result_type_id)
                        }}>В
                            Финал
                        </button>
                        <div className={s.static_res_sub_main}>
                            {el.result.map((res, i) => <>
                                <div className={s.static_res_sub_main_item}
                                     key={res.discipline_result_id + 'we'}>
                                    {res.discipline_short}
                                </div>
                                {ind === 0 && <h3
                                    style={{position: 'relative', bottom: '30px', left: '20px'}}
                                >FC</h3>}

                                <div className={s.static_res_sub_main_item}
                                     style={{marginLeft: ind === 0 ? '-10px' : '10px', padding: '5px'}}>
                                    {res.factor}
                                </div>
                                {el.result.length === (i + 1) ? '' : <span className={s.plus}>+</span>}
                            </>)}
                        </div>
                    </div>
                })}
            </div>

            <div>
                <hr style={{marginBottom: '15px', border: '3px solid #ddd'}}/>
                <h2>Гибкие суммарные формулы</h2>
                {dynamicFormulaStore.allSumFormulas.map((item, index) =>
                    <DynamicFormulaRow key={item.formula_id}
                                       index={index}
                                       formula={item}
                                       ageGroupSelect={ageGroupSelect}
                                       deleteSumFormula={deleteSumFormula}
                                       renameSumFormula={renameSumFormula}
                                       deleteFormulaId={deleteFormulaId}
                    />
                )}
                <div className={s.added_dynamic_box}>
                    <input type="text" value={newFormulaName} placeholder={'Название формулы'}
                           onChange={(e) => setNewFormulaName(e.target.value)}/>

                    <div className={s.add} onClick={createSumFormula}>
                        +
                    </div>
                </div>
                <hr style={{marginBottom: '15px', border: '3px solid #ddd'}}/>
            </div>

            <div className={s.dinamic_items}>
                {store.setting_sorev.dynamic_res.map((el, index) =>
                    <Row
                        ageGroupSelect={ageGroupSelect}
                        discipline={store.setting_sorev.discipline}
                        key={el.result_dinamic_type_id}
                        index={index} {...el}/>)}
            </div>

            <div className={s.added_box}>
                <input type="text" value={name} placeholder={'Название типа'}
                       onChange={(e) => setName(e.target.value)}/>

                <div className={s.add} onClick={handleAdded}>
                    +
                </div>
            </div>
        </div>
    );
});

export default Right;
